///
// Stage video controls
///

function initializeVideoControl(videoElementSelector, controlButtonSelector) {
  const videoElement = document.querySelector(videoElementSelector);
  const playPauseButton = document.querySelector(controlButtonSelector);

  playPauseButton.addEventListener('click', () => {
    playPauseButton.classList.toggle('playing');
    if (playPauseButton.classList.contains('playing')) {
      videoElement.play();
    } else {
      videoElement.pause();
    }
  });

  videoElement.addEventListener('ended', () => {
    playPauseButton.classList.remove('playing');
  });
}

// Init video control
initializeVideoControl('.ubbm-stage__video video', '.ubbm-stage__video .video-control');
